import type { Props } from "./v1/LogoV1.types";

export const logoLabels = {
  "app-store": "Laden im App Store",
  ehi: "EHI Geprüfter Online-Shop",
  facebook: "Facebook",
  github: "Github",
  instagram: "Instagram",
  linkedin: "LinkedIn",
  mastercard: "Mastercard Logo",
  otto: "OTTO Logo",
  "otto-ai": "OTTO AI Logo",
  "otto-app": "OTTO App",
  "otto-payments": "OTTO Payments Logo",
  "otto-up": "OTTO-Up Logo",
  "otto-up-claim": "OTTO-Up Claim",
  "otto-up-claim-white": "OTTO-Claim",
  "otto-up-white": "OTTO-Up Logo",
  "otto-white": "OTTO Logo",
  paypal: "PayPal Logo",
  "paypal-monogram": "PayPal Logo",
  pinterest: "Pinterest",
  "play-store": "Jetzt bei Google Play",
  "sepa-horizontal": "SEPA Lastschrift Logo",
  "sepa-vertical": "SEPA Lastschrift Logo",
  slogan: "Otto... find ich gut.",
  snapchat: "Snapchat",
  tiktok: "Tiktok",
  up: "OTTO-Up Logo",
  "up-white": "OTTO-Up Logo",
  visa: "Visa Logo",
  xing: "Xing",
  youtube: "Youtube",
} satisfies Record<Props["logo"], string>;
